<template>
  <div id="forgotPassword">
    <v-form ref="passwordForm">
      <v-container>

        <v-layout wrap class="pr-4 pl-4"> 
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-layout wrap>
            <v-flex xs12 sm6>
              <v-text-field v-model="password.old" label="Enter Current Password" type="password" class="requiredfield pr-4 pl-4 pb-4" @input="changedData" :rules="[rules.required]"></v-text-field>
              <v-text-field ref="password"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="enterPasswordRules"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                @input="changedData"
                class="input-group--focused requiredfield pr-4 pl-4 pb-4"
                hint="At least 8 characters"
                label="Enter New Password"
                v-model="password.new"
              ></v-text-field>
              <v-text-field
                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                :rules="confirmPasswordRules"
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2"
                @input="changedData"
                class="input-group--focused requiredfield pr-4 pl-4 pb-4"
                hint="At least 8 characters"
                label="Re - Enter New Password"
                v-model="password.confirm"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm5">
            </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right ">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session config */
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { checkWPToken, requestToWPPF, request } from '../helpers/helpers';
import swal from 'sweetalert2';
export default {
  name: 'forgot-password',
  data: () => ({
    config: config,
    password: {
      old: '',
      new: '',
      confirm: ''
    },
    show1: false,
    show2: false,
    rules: {
      required: value => !!value || 'Field is required.',
    },
    selectedData: false,
  }),
  computed: {

    ...mapGetters(['Account', 'Agency']),
    enterPasswordRules () {
      return [
        v => !!v || 'Field is required.',
        v => !!v && v.length >= 8 || 'Password cannot be less than 8 characters',
        v => /(?=.*?[A-Z])/.test(v) || 'Password must have upper case letter',
        v => /(?=.*?[0-9])/.test(v) || 'Password must have one number',
        v => v === this.password.confirm || this.password.confirm.length < 8 || 'Password should be match with confirm password'
      ];
    },
    confirmPasswordRules () {
      return [
        v => !!v || 'Please re-enter the password',
        v => v === this.password.new || 'Password should be match with new password',
        v => /(?=.*?[A-Z])/.test(v) || 'Password must have upper case letter',
        v => /(?=.*?[0-9])/.test(v) || 'Password must have one number',
        v => !!v && v.length >= 8 || 'Password cannot be less than 8 characters'
      ];
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  watch: {
    'password.new': function (after, before) {
      if (after && after.length >= 8 && after === this.password.confirm) {
        this.$refs.passwordForm.resetValidation();
      }
    },
    'password.confirm': function (after, before) {
      if (after && after.length >= 8 && after === this.password.new) {
        this.$refs.passwordForm.resetValidation();
      }
    }
  },
  methods: {
    async save () {
      if (this.$refs.passwordForm.validate()) {
        let passwordUrl = 'User/Password/Update';
        let payload = { current_password: this.password.old, new_password: this.password.new };
        let sessionUser = session.getSession();
        if (sessionUser.adminUser) {
          payload.user = sessionUser.user.id;
        }
        let response = await request(passwordUrl, 'POST', payload);
        if (response.error) {
          swal.fire({
            type: 'warning',
            title: '<b>Error</b>',
            html: response.error,
            showConfirmButton: false,
            timer: 2500
          });
        } else {
          swal.fire({
            type: 'success',
            title: 'The password was updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: async () => {
              this.hideButtons();
            }
          });
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.$refs.passwordForm.reset();
      this.selectedData = false;
      this.password.confirm = '';
      // let pathUrl = session.user().role === 'parent' ? '/' : 'agency/dashboard';
      // this.$router.push({ path: pathUrl });
    },

  }
};
</script>


<style lang="css" scoped>
  .requiredfield >>> label::before {
    content: "*";
    color: red;
    padding-right:3px;
  }
  .button-container{
    min-height:60px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ChangePassword.vue